/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useEffect } from "react";
import { useOnClickOutside } from "../../../../../CommonMethods/OutsideClick";
import { ShimmerTitle } from 'react-shimmer-effects'
const DropDownComponent = ({
    placeHolder,
    id,
    divClassName,
    options,
    handleOnchangeInput,
    value,
    dropDownName,
    index,
    buttonDisabled,
    buttonClassName,
    showErrorBorder,
    dropdownId,
    test_id,
    SameName,
    optionsKey,
    divRef,
    buttonNameRef,
    dropdownNameRef,
    isOpen,
    setisOpen,
    loading,
    applyBGForDisabled
}) => {

    /* The `useOnClickOutside` is a custom hook that is used to detect clicks outside of a specified
    element. In this case, it is used to detect clicks outside of the dropdown component. When a click
    is detected outside of the dropdown component, the `setisOpen` function is called to set the
    `isOpen` state to `false`, effectively closing the dropdown. */
    useOnClickOutside(divRef, () => {
        setisOpen(false);
    });

    /**
     * The function calculates the position of a dropdown menu based on the available space on the screen.
     */
    const calculateDropdownPosition = () => {
        const buttonRect = buttonNameRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - buttonRect.bottom-40;
        //40px
        const dropdownHeight =dropdownNameRef.current.clientHeight;
    
        if (spaceBelow < dropdownHeight) {
            dropdownNameRef.current.style.top = `-${dropdownHeight}px`;
        } else {
            dropdownNameRef.current.style.top = '100%';
        }
    };

    /* The `useEffect` hook is used to perform side effects in a functional component. In this case, the
    `useEffect` hook is used to add an event listener for the `resize` event on the window object. When
    the `resize` event is triggered, the `calculateDropdownPosition` function is called to recalculate
    the position of the dropdown menu based on the available space on the screen. */
    useEffect(() => {
        window.addEventListener('resize', calculateDropdownPosition);
        calculateDropdownPosition(); // Initial position calculation
        return () => {
            window.removeEventListener('resize', calculateDropdownPosition);
        };
    }, [isOpen]);
    
    return (
        <div className={divClassName} data-te-dropdown-ref id={id} ref={divRef}>
            <button
                ref={buttonNameRef}
                disabled={buttonDisabled !== undefined && buttonDisabled}
                title={value}
                onClick={() => setisOpen(!isOpen)}
                className={`slct-inpt-fld transition duration-150 ease-in-out  ${showErrorBorder == true ? 'redBorder' : ''}
                ${buttonDisabled !== undefined && buttonDisabled && applyBGForDisabled?'bg-[#E6E8EA]':'bg-white'}`}
                type="button"
                id={dropDownName}
                data-testid = {test_id}
                
                data-te-dropdown-toggle-ref
                aria-expanded="false"
            >
                <p
                    className={`text-f7 ${
                        (value === "" || value === undefined || value === true)
                            ? "text-[#818E98]"
                            : "text-[#031624]"
                    } font-normal `}
                >
                    {(value === "" || value === undefined || value === true)
                        ? placeHolder
                        : value}
                </p>
                <img
                    src="/images/dropdown-icon.png"
                    alt="icon"
                    className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${
                        isOpen ? "transform rotate-180" : ""
                    }`}
                />
            </button>
            <ul
                ref={dropdownNameRef}
                className={`slct_drp_dwn min-w-full ${
                    isOpen ? "" : "hidden"
                } [&[data-te-dropdown-show]]:block `}
                aria-labelledby="dropdownMenu_acdemic_year"
                data-te-dropdown-menu-ref
                title={value}
            >
                <li className="max-h-[220px] overflow-auto scroll-bar">
                    <ul>
                        {loading ? (
                            <p className="text-2xl font-bold text-[#031624] mb-4 mt-4 px-2"><ShimmerTitle line={1} gap={6} variant="secondary" /></p>
                        ) : (
                            options?.length > 0 ? (
                                options.map((option, i = 0) => (
                                    <li
                                        key={i}
                                        id={dropdownId === undefined ? dropDownName : SameName === undefined ? `${dropDownName}_${i}` : optionsKey === undefined ? option.name : option[optionsKey]}
                                        onClick={(e) => {
                                            handleOnchangeInput(dropDownName, option, index),
                                            setisOpen(false);
                                        }}
                                    >
                                        <a
                                            title={optionsKey === undefined ? option.name : option[optionsKey]}
                                            className="slct_drp_dwn_optn"
                                        >
                                            {optionsKey === undefined ? option.name : option[optionsKey]}
                                        </a>
                                    </li>
                                ))) :
                                (
                                    <li
                                        key=""
                                        id="select-option"
                                        onClick={(e) => {
                                            setisOpen(false);
                                        }}
                                    >
                                        <a className="slct_drp_dwn_optn">
                                            - No options available -
                                        </a>
                                    </li>
                                ))}
                    </ul>
                </li>
            </ul>
        </div>
    );
};

export default DropDownComponent;
